// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Container } from '@crehana/ui';
import dynamic from 'next/dynamic';

import CourseListSkeleton from './components/CourseListSkeleton';

const LazyCoursesWithRules = dynamic(
  () =>
    import(
      /* webpackChunkName: "user-dashboard-my-courses-rules" */ './MyCoursesWithRules'
    ),
  {
    loading: () => (
      <Container type="dashboard">
        <CourseListSkeleton />
      </Container>
    ),
    ssr: false,
  },
);

export default LazyCoursesWithRules;
